import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Counter = ({ value, label, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(value);
    if (start === end) return;

    const incrementTime = Math.abs(Math.floor(duration / end));
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [value, duration]);

  return (
    <div className="text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-4xl md:text-5xl font-bold text-white"
      >
        {count}+
      </motion.div>
      <p className="mt-2 text-white/80 font-medium">{label}</p>
    </div>
  );
};

export default function Counters() {
  return (
    <section className="relative bg-gray-900 py-20 overflow-hidden">
      {/* Dark parallax background */}
      <motion.div
        className="absolute inset-0"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.3 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        style={{
          backgroundImage: "url('/dark-parallax.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-12">
        <Counter value={150} label="Units Delivered" />
        <Counter value={2} label="Years Experience" />
        <Counter value={10} label="Projects Completed" />
        <Counter value={200} label="Happy Clients" />
      </div>
    </section>
  );
}
